var _defs, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevgeniusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dgGradient",
    x1: 16,
    y1: 12,
    x2: 116,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B86E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dgInner",
    x1: 36,
    y1: 36,
    x2: 94,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 108,
    height: 108,
    rx: 30,
    fill: "url(#dgGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 80,
    height: 80,
    rx: 20,
    fill: "url(#dgInner)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 52C48 46.4772 52.4772 42 58 42H70C75.5228 42 80 46.4772 80 52V76C80 81.5228 75.5228 86 70 86H58C52.4772 86 48 81.5228 48 76V52Z",
    fill: "url(#dgGradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 54H70C72.2091 54 74 55.7909 74 58V70C74 72.2091 72.2091 74 70 74H61C58.7909 74 57 72.2091 57 70V58C57 55.7909 58.7909 54 61 54Z",
    fill: "#E2F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevgeniusLogo);
export default __webpack_public_path__ + "static/media/devgenius-logo.7f0d96e2ae8a9ecc41fc2d894ed3ae8f.svg";
export { ForwardRef as ReactComponent };